/**
 * UUID minting with a fallback for environments without crypto.randomUUID.
 *
 * Single home for idempotency keys so every flow (signup, provisioning,
 * client creation) mints them the same way. The fallback keeps UUID shape
 * because the backend validates idempotency keys as UUIDs.
 */

export function newIdempotencyKey(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
}
